import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class ventasService {

    /******* QUERIES ******/


    async listar() {
        const response = await axios
            .get(`${ERP}ventas/servicio`)
            .then(response => {
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

}

export default new ventasService();